export default __webpack_public_path__ + "static/media/3.4f68bd9d.png";